import { useContext } from 'react';

import { SessionContext } from './SessionContext';
import type { SessionContextValue } from './sessionTypes';

/** Access the application session. Must be used within a `SessionProvider`. */
export function useSession(): SessionContextValue {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider.');
  }
  return context;
}
